module.exports = __webpack_public_path__ + "img/c3.eefe5d74.png";